import { newsConstants } from "./constants";
import { defAction } from "../../../helpers/defaultAction";
import api from "./api";

export const newsActions = {
  createNews,
  getNews,
  sendFile,
  sendFiles,
  downloadNewsFile,
  changeNews,
  deleteNews,
  getOneNews
};

function changeNews(values) {
  const dispatchObj = {
    constants: newsConstants.changeNews,
    service: {
      func: api.changeNews,
      params: values,
    }
  };
  return defAction(dispatchObj);
}
function deleteNews(values) {
  const dispatchObj = {
    constants: newsConstants.deleteNews,
    service: {
      func: api.deleteNews,
      params: {id:values},
    }
  };
  return defAction(dispatchObj);
}
function createNews(values) {
  const dispatchObj = {
    constants: newsConstants.createNews,
    service: {
      func: api.createNews,
      params: values,
    }
  };
  return defAction(dispatchObj);
}

function getNews(values) {
  const dispatchObj = {
    constants: newsConstants.getNews,
    service: {
      func: api.getNews,
      params:values
    }
  };
  return defAction(dispatchObj);
}
function getOneNews(values) {
  const dispatchObj = {
    constants: newsConstants.getOneNews,
    service: {
      func: api.getOneNews,
      params:values
    }
  };
  return defAction(dispatchObj);
}

function sendFile(values) {
  const dispatchObj = {
    constants: newsConstants.sendFile,
    service: {
      func: api.sendFile,
      params: values,
    }
  };
  return defAction(dispatchObj);
}
function sendFiles(values) {
  const dispatchObj = {
    constants: newsConstants.sendFiles,
    service: {
      func: api.sendFiles,
      params: values,
    }
  };
  return defAction(dispatchObj);
}

function downloadNewsFile(values) {
  const dispatchObj = {
    constants: newsConstants.downloadFile,
    service: {
      func: api.downloadNewsFile,
      params: values,
    }
  };
  return defAction(dispatchObj);
}